import VueI18n from "vue-i18n";
import Vue from "vue";
import en from "@/locales/en/en.json";
import de from "@/locales/de/de.json";
import getLocale from "@/utils/locale";

Vue.use(VueI18n);

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: "en",
  messages: { en, de }
});
